<template>
  <main class="view">
    <div class="information">
      <div v-html="text"></div>
      <div class="links">
        <a v-if="email" :href="'mailto:' + email">{{ email }}</a>
        <a v-if="instagram" :href="instagram" target="_blank">instagram</a>
      </div>
    </div>
  </main>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { openLinksOutside } from '@/utils'

const kql = useStore();

const text = computed(() => openLinksOutside(kql.page?.text || ''));
const email = computed(() => kql.page?.content?.email || '');
const instagram = computed(() => kql.page?.content?.instagram || '');
</script>
